import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { ExaminerLocationDetail, ExaminerLocationSelection } from "../../examiner/models/exminer-location-selection.model";
import { PilotExaminerSearchQueryEntityExt } from "../../../meta-data/extensions/pilot-examiner-search-query-ext.model";
import { ExaminerSlotSelection } from "../models/examiner-slot-selection.model";

@Injectable({
    providedIn: 'root'
})


export class ScheduleSelectorService {

    static storedData: {
        examinerLocationSelection: ExaminerLocationSelection;

        examinerLocationDetails: ExaminerLocationDetail[];
    }

    get examinerLocationSelection(): ExaminerLocationSelection {
        return ScheduleSelectorService.storedData.examinerLocationSelection;
    }

    set examinerLocationSelection(value: ExaminerLocationSelection) {
        ScheduleSelectorService.storedData.examinerLocationSelection = value;
    }

    get examinerLocationDetails(): ExaminerLocationDetail[] {
        return ScheduleSelectorService.storedData.examinerLocationDetails;
    }

    set examinerLocationDetails(value: ExaminerLocationDetail[]) {
        ScheduleSelectorService.storedData.examinerLocationDetails = value;
    }

    constructor() {
        if (!ScheduleSelectorService.storedData) {
            ScheduleSelectorService.storedData = {
                examinerLocationSelection: {
                    confirmed: false,
                    totalSelected: 0,
                    totalAllowed: 1,
                    allowConfirm: false,
                    currentSearchResult: null
                },
                examinerLocationDetails: []
            };
        }
    }

    // examinerLocationDetails: ExaminerLocationDetail[] = [];

    selectionChange: Subject<any> = new Subject<any>();
    countChange: Subject<any> = new Subject<any>();

    confirm: Subject<any> = new Subject<any>();

    initSelections(totalAllowed: number, allowConfirm: boolean, searchResults: PilotExaminerSearchQueryEntityExt[]) {
        this.examinerLocationSelection = {
            confirmed: false,
            totalSelected: 0,
            totalAllowed: totalAllowed,
            allowConfirm: allowConfirm,
            currentSearchResult: null
        };

        this.examinerLocationDetails = [];

        for (const searchResult of searchResults) {
            const detail: ExaminerLocationDetail = {
                searchResult: searchResult,
                scheduleDateTime: [],
                isSelected: false
            };

            this.examinerLocationDetails.push(detail);
        }

        if (searchResults.length > 0) {
            this.examinerLocationDetails[0].isSelected = true;
        }

        this.selectionChange.next();
    }

    getSelections(): ExaminerSlotSelection[] {
        const selections: ExaminerSlotSelection[] = [];

        for (const detail of this.examinerLocationDetails) {
            if (detail.scheduleDateTime.length > 0) {
                for (const dateTime of detail.scheduleDateTime) {
                    selections.push({
                        searchResult: detail.searchResult,
                        scheduleDateTime: dateTime
                    });
                }
            }
        }

        return selections;
    }

    selectDetail(index: number) {
        for (const detail of this.examinerLocationDetails) {
            detail.isSelected = false;
        }

        this.examinerLocationDetails[index].isSelected = true;

        this.selectionChange.next();
    }

    isSelected(index: number): boolean {
        return this.examinerLocationDetails[index]?.isSelected || false;
    }

    showConfirmButton(index: number): boolean {
        const currentDetail = this.examinerLocationDetails[index];

        if (currentDetail.isSelected && currentDetail?.scheduleDateTime?.length > 0) {
            return true;
        }
    }

    confirmSelection(index: number) {
        const currentDetail = this.examinerLocationDetails[index];

        this.confirm.next({});
    }

    getTotalAllowed(index: number): number {
        const currentDetail = this.examinerLocationDetails[index];

        if (!currentDetail) {
            return 0;
        }

        return this.examinerLocationSelection.totalAllowed - (this.examinerLocationSelection.totalSelected - currentDetail.scheduleDateTime.length);
    }

    getSelectedCount(index: number): number {
        const currentDetail = this.examinerLocationDetails[index];

        return currentDetail.scheduleDateTime.length;
    }

    setDates(index: number, selectedDates: string[]) {
        const currentDetail = this.examinerLocationDetails[index];

        currentDetail.scheduleDateTime = selectedDates;

        let selectedCount = 0;
        for (const detail of this.examinerLocationDetails) {
            selectedCount += detail.scheduleDateTime.length;
        }

        this.examinerLocationSelection.totalSelected = selectedCount;

        this.countChange.next(selectedCount);
    }








}